export const TIER_META = [
  {
    level: 0,
    labelKey: 'tiers.novice',
    defaultLabel: 'Novice Player',
    abbr: '--',
    icon: '🧢',
    color: 'linear-gradient(135deg, #9e9e9e, #bdbdbd)',
    text: '#111'
  },
  {
    level: 1,
    labelKey: 'tiers.copper',
    defaultLabel: 'Copper Trials',
    abbr: 'Cu',
    icon: '⚔️',
    color: '#b87333',
    text: '#1f0c02'
  },
  {
    level: 2,
    labelKey: 'tiers.silver',
    defaultLabel: 'Silver Contender',
    abbr: 'Ag',
    icon: '🛡️',
    color: '#c0c0c0',
    text: '#1c1c1c'
  },
  {
    level: 3,
    labelKey: 'tiers.gold',
    defaultLabel: 'Golden Champion',
    abbr: 'Au',
    icon: '👑',
    color: '#ffd700',
    text: '#2b1a01'
  }
];

export function getTierMeta(tier = 0) {
  if (tier < 0 || tier >= TIER_META.length) {
    return TIER_META[0];
  }
  return TIER_META[tier];
}
